import { render, staticRenderFns } from "./TripsNewFilter.vue?vue&type=template&id=5bca0f71&"
import script from "./TripsNewFilter.vue?vue&type=script&lang=js&"
export * from "./TripsNewFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports